/**
 * Created by User on 30/9/2559.
 */
import {Component, OnDestroy, OnInit, ViewChild, HostBinding, NgZone} from '@angular/core';
import { Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { AppComponent } from 'app/app.component';
import { SocialLogin } from '../social-login';
import { TwofactorComponent } from '../twofactor/twofactor.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { LoadingButtonComponent } from 'app/shared/loading-button/button';
import { Observable } from 'rxjs';
import { Toast } from '../../shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import jwt_decode from "jwt-decode";

declare let FB: any;
declare var google: any;
declare const google_id: string;

@Component({
   selector: 'app-login',
   templateUrl: './login.component.html',
   styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
   @HostBinding('class') fx = 'fx-for-login flex-center';
   @ViewChild('login') loginButton: LoadingButtonComponent;
   user_name: string;
   password1: string;
   busy: boolean;
   visible = false;
   idpMessage = '';
   idpRedirectUrl = '';

   constructor(private router: Router, private service: IdexService, public social: SocialLogin,
               private dialog: MatDialog, private app: AppComponent, private toast: Toast,
               private translate: TranslateService, private zone: NgZone) {
   }

   ngOnInit(): void {
      document.title = 'Sign In - zDOX';
      this.service.setUser();
      this.service.removeMicrosoftAuth();
      this.initGoogle();

   }

   ngOnDestroy(): void {
      document.title = 'zDOX';
   }

   onSubmit(): void {
      this.toast.dismiss();
      this.idpMessage = '';
      this.idpRedirectUrl = '';
      this.busy = true;
      const observer = this.service.login(this.user_name, this.password1);
      this.subscribe(observer);
   }

   signInWithFacebook(): void {
      this.toast.dismiss();
      this.social.withFacebook().subscribe(result => {
         this.busy = true;
         this.loginButton.busy();
         const observer = this.service.loginWith(result);
         this.subscribe(observer);
      }, error => {
         this.toast.error(error);
         this.loginButton.reset();
         this.busy = false;
      });
   }

   private subscribe(observer: Observable<any>): void {
      observer.subscribe(result => {
         this.zone.run(() => {
            this.loggedIn(result);
         });
      }, error => {
         if(error.status === 591) {
            this.dialog.open(TwofactorComponent, {
               disableClose: true,
               data: {mode: 'login', key: error.error.key, message: error.error.message}
            }).afterClosed().subscribe(data => {
               if (data) {
                  this.loggedIn(data);
               } else {
                  this.loginButton.reset();
                  this.busy = false;
               }
            });
         } else if (error.redirectUrl) {
            // Domain restricted to an Identity Provider: show the message + a link to continue via IdP.
            this.zone.run(() => {
               this.idpMessage = error.message;
               this.idpRedirectUrl = error.redirectUrl;
               this.loginButton.reset();
               this.busy = false;
            });
         } else {
            this.toast.error(error.message);
            this.zone.run(() => {
               this.loginButton.reset();
               this.busy = false;
               FB.logout();
               localStorage.removeItem('access_token');
               localStorage.removeItem('onedrive_callback');
               localStorage.removeItem('onedrive_action');
               sessionStorage.removeItem('access_token_google');
            });
         }
      });
   }

   private loggedIn(data: any): void {
      this.service.setUser(data);
      this.service.setIdpLogin(false);
      this.app.setUser(data);
      let taskId = '';
      let shareId;
      let docId;
      if (window.location.pathname !== undefined) {
         const url = window.location.pathname.replace('/idex', '');
         if (url.startsWith('/login/')) {
            const de = decodeURIComponent(url);
            if (de.startsWith('/login/share/')) {
               shareId = de.replace('/login/share/', '').split('/')[0];
            } else if (de.startsWith('/login/file/')) {
               docId = de.replace('/login/file/', '');
            } else if (de.startsWith('/login/signdoc/')) {
               taskId = url.replace('/login/signdoc/', '').split('/')[0];
            }
         }
      }

      if (taskId !== '') {
         this.router.navigate(['/signdoc/', taskId]);
      } else if (shareId !== undefined) {
         this.router.navigate(['/share/', shareId]);
      } else if (docId !== undefined) {
         this.router.navigate(['/file/', docId]);
      } else {
         this.router.navigate(['/']);
      }
   }

   goRegister(): void {
      this.router.navigateByUrl('/signup');
   }

   forgotPassword() {
      this.dialog.open(ForgotPasswordComponent, {disableClose: true});
   }

   initGoogle(): void {
      //   migrate google
      const that = this;
      var offsetWidth = document.getElementById('link_loginFacebook').offsetWidth;
      function handleCredentialResponse(response) {
         if (response.credential) {
            sessionStorage.setItem('token_google', response.credential);
            oauthSignIn(jwt_decode(response.credential));
         }
      }

      function oauthSignIn(googleInfo) {
         const googleEmail = googleInfo.email;
         const client = google.accounts.oauth2.initTokenClient({
            client_id: google_id,
            scope: that.service.SCOPE,
            hint: googleEmail,
            prompt: '',// Specified as an empty string to auto select the account which we have already consented for use.
            callback: (tokenResponse) => {
               sessionStorage.setItem('access_token_google', tokenResponse.access_token);
               that.toast.dismiss();
               that.social.withGoogle().subscribe(result => {
                  that.busy = true;
                  that.loginButton.busy();
                  const observer = that.service.loginWith(result);
                  that.subscribe(observer);
               }, error => {
                  that.toast.error(error);
                  that.loginButton.reset();
                  that.busy = false;
               });
            },
         });
         client.requestAccessToken();
      }

      google.accounts.id.initialize({
         client_id: google_id,
         callback: handleCredentialResponse,
         use_fedcm_for_prompt: true,
         itp_support: true
      });
      let lang;
      switch (localStorage.getItem('lang')) {
         case 'th':
            lang = 'th';
            break;
         case 'en':
            lang = 'en';
            break;
         case 'cn':
            lang = 'zh_CN';
            break;
         default :
            lang = 'en';
            break;
      }

      const loginGoogleBtn = document.getElementById('link_loginGoogle');

      google.accounts.id.renderButton(loginGoogleBtn,  { type: 'standard',
         theme: 'outline',
         size: 'medium',
         locale: lang,
         shape: 'pill',
         width: offsetWidth + 'px'}  // customization attributes
      );

      google.accounts.id.prompt(); // also display the One Tap dialog
   }

}
